import React, { lazy } from 'react';
import { Trans } from '@lingui/macro';

import { canSeeWorkforceSummary } from './model/workforce';

const WorkforceSummaryPage = lazy(() =>
  import('./pages/summary').then(module => ({
    default: module.WorkforceSummaryPage,
  })),
);

export const routes = [
  {
    path: '/hr/saudization',
    component: WorkforceSummaryPage,
    exact: true,
    accessCheck: canSeeWorkforceSummary,
    navigation: {
      name: <Trans>Saudization Index</Trans>,
      shortName: 'SI',
    },
  },
];
